<mat-form-field appearance="outline" class="dosage-unit-search-field">
  <mat-label>{{ label }}</mat-label>
  <input
    required
    type="text"
    matInput
    placeholder="Search dosage units"
    [formControl]="formControl"
    [matAutocomplete]="dosageUnitAuto"
    (input)="onSearchInput($event)"
  />
  <mat-autocomplete
    #dosageUnitAuto="matAutocomplete"
    [displayWith]="displayDosageUnit"
    autoActiveFirstOption
    panelClass="medicine-lookup-autocomplete-panel"
  >
    @for (unit of dosageUnits; track unit.id) {
      <mat-option [value]="unit">{{ unit.unit }}</mat-option>
    }
  </mat-autocomplete>
  <mat-icon matPrefix>search</mat-icon>
  <button type="button" matSuffix mat-icon-button (click)="createDosageUnit($event)">
    <mat-icon>add</mat-icon>
  </button>
  @if (control.invalid && (control.dirty || control.touched)) {
    <mat-error>Dosage unit is invalid</mat-error>
  }
  @if (isSearching) {
    <mat-hint>Searching...</mat-hint>
  }
</mat-form-field>
